import * as React from 'react';
import { sanitizeHtml } from './sanitizer';
export var RenderHtml = function (props) {
    var skipSanitation = props.dangerouslyDisableSanitation === 'i-know-what-i-am-doing';
    var html = skipSanitation ? props.html : sanitizeHtml(props.html);
    var htmlObj = { __html: html };
    return React.createElement("span", { dangerouslySetInnerHTML: htmlObj, className: props.className });
};
//# sourceMappingURL=index.js.map